const route = {
	path: '/login',
	name: 'login',
	meta: {
		title: process.env.COMPANY_LOGIN_TITLE,
	},
	component: () => import('@/pages/page-login'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/login.js